<template>
  <svg
    role="img"
    aria-label="Trustpilot"
    viewBox="0 0 1132.8 278.2"
    xmlns="http://www.w3.org/2000/svg"
  >
    <use href="#trustpilot-logo" />
  </svg>
</template>

<script>
export default {
  name: 'TrustpilotLogo',
};
</script>
